import {Component, Input} from '@angular/core';

@Component({
  selector: 'ui-link-box',
  templateUrl: './link-box.component.html',
  styleUrls: ['./link-box.component.scss']
})
export class LinkBoxComponent {

  @Input('title') title: string = '';
  @Input('links') links: any[] = [];


  tempLinks: any[] = [
    {
      'text': 'Comunicazioni',
      'type': 'warning',
      'label': '6 non lette'
    },
    {
      'text': 'Calendario',
      'type': 'success',
      'label': '1 appuntamento'
    },
    {
      'text': 'Shop',
      'type': 'warning'
    },
    {
      'text': 'Impostazioni',
      'type': 'success'
    },
  ];

}
